<template>
  <PModal
    title="Une notification vient d'être envoyée à :"
    :model-value="signedNotified.names.value.length > 0"
    @update:model-value="onUpdate"
  >
    <template #default>
      <ul>
        <li v-for="(name, index) in signedNotified.names.value" :key="index" class="odd:bg-grey-950 even:bg-grey-1000">
          <span>{{ name }}</span>
        </li>
      </ul>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { PModal } from "@pasta/box-v2";
import { useShowSignedNotified } from "../composable/useShowSignedNotified";

const signedNotified = useShowSignedNotified();

function onUpdate(isOpen: boolean) {
  if (isOpen) {
    return;
  }
  signedNotified.names.value = [];
}
</script>
